var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPeople32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 11C20.4004 8.56995 18.4301 6.59961 16 6.59961C13.5699 6.59961 11.5996 8.56995 11.5996 11C11.5996 13.4301 13.5699 15.4004 16 15.4004V17C12.6863 17 10 14.3137 10 11C10 7.68629 12.6863 5 16 5C19.3137 5 22 7.68629 22 11C22 14.3137 19.3137 17 16 17V15.4004C18.4301 15.4004 20.4004 13.4301 20.4004 11Z",
    fill: "#FA6700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0204 18C21.9798 18 26 22.0293 26 27H24.3677C24.3677 22.9331 21.0781 19.636 17.0204 19.636H14.9796C10.9219 19.636 7.63229 22.9331 7.63229 27H6C6 22.0293 10.0202 18 14.9796 18H17.0204Z",
    fill: "#FA6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPeople32);
export default __webpack_public_path__ + "static/media/ico_people_32.d89014658e99da3296b3a355a0c52d48.svg";
export { ForwardRef as ReactComponent };